/* eslint-disable max-len */
import { useTranslate } from "react-admin";
import * as User from "../providers/user";
import { Avatar } from "@mui/material";

const DashboardArtists = ({ data }: { data: any }) => {
  const { permissions } = User.useUser();
  const translate = useTranslate();

  const artists = data?.artists || [];

  if (!permissions?.companyId) return null;

  return (
    <div className="w-full h-full">
      <div
        className="w-full h-[52px] bg-[#FAF9F7] rounded-t-lg grid grid-cols-8 border-b border-[rgba(224,224,224,1)] 
      text-[14px] leading-[20.02px] font-[400] text-mono-primaryTextColor"
      >
        <div className="col-span-4 w-full h-full flex items-center pl-4 pr-2">
          {translate("dashboard.artist")}
        </div>
        <div className="col-span-2 w-full h-full flex items-center px-2">$</div>
        <div className="col-span-1 w-full h-full flex items-center justify-end px-2">
          Svcs.
        </div>
        <div className="col-span-1 w-full h-full flex items-center justify-end pl-2 pr-4">
          Hrs.
        </div>
      </div>

      <div className="w-full h-[calc(100%-51px)] overflow-y-auto text-[14px] leading-[20.02px] rounded-lg font-[400] text-mono-primaryTextColor">
        {artists.length === 0 && (
          <div className="w-full h-[200px] bg-[#FAF9F7] flex justify-center items-center rounded-b-lg">
            {translate("dashboard.no_data_yet")}
          </div>
        )}
        {artists.map((artist: any) => (
          <div
            key={artist.id}
            className="w-full h-[52px] grid grid-cols-8 bg-[#FAF9F7] last:rounded-b-lg"
          >
            <div className="col-span-4 w-full h-full flex gap-[6px] items-center pl-4 pr-2">
              <Avatar
                sx={{
                  bgcolor: "rgba(238, 234, 228, 0.9)",
                  color: "rgba(48, 47, 46, 0.95)",
                  width: "32px",
                  height: "32px",
                  fontFamily: "Inter",
                  fontSize: "18px"
                }}
                alt={artist.full_name}
                src={artist.photo_url || "monogram"}
              />
              <span className="line-clamp-1 break-all">{artist.full_name}</span>
            </div>
            <div className="col-span-2 w-full h-full flex items-center px-2">
              ${artist.total_amount}
            </div>
            <div className="col-span-1 w-full h-full flex items-center justify-start">
              {artist.services_count}
            </div>
            <div className="col-span-1 w-full h-full flex items-center justify-end pl-2 pr-4">
              {artist.total_hours}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardArtists;
